import React from 'react';
import { motion } from 'framer-motion';
import { CheckCheckIcon } from 'lucide-react';
type TestimonialProps = {
  name: string;
  avatar: string;
  message: string;
  time: string;
};

/** Chat-bubble style testimonial resembling a messaging screenshot. */
export function Testimonial({
  name,
  avatar,
  message,
  time
}: TestimonialProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.3
  }} transition={{
    duration: 0.4
  }} className="flex items-start gap-3 rounded-2xl bg-white p-4 shadow-sm" data-id="element-153" data-mp="p60f3xjaverm">
      <img src={avatar} alt={`Foto de perfil de ${name}`} className="h-11 w-11 flex-shrink-0 rounded-full object-cover" data-id="element-154" data-mp="1j0nh9ptjf1u" />
      <div className="min-w-0 flex-1" data-id="element-155" data-mp="6ezg59i6jj82">
        <p className="text-sm font-bold text-sage-deep" data-id="element-156" data-mp="3omovj1mf8oue">{name}</p>
        <div className="mt-1 rounded-2xl rounded-tl-sm bg-[#e6f2dd] px-4 py-3" data-id="element-157" data-mp="3opb5t90p5igb">
          <p className="text-sm leading-relaxed text-ink/80" data-id="element-158" data-mp="3to4hqx0c51ed">{message}</p>
          <p className="mt-1.5 flex items-center justify-end gap-1 text-[10px] text-ink/40" data-id="element-159" data-mp="3v8l200nwsiyx">
            {time}
            <CheckCheckIcon className="h-3.5 w-3.5 text-sage" aria-hidden="true" data-id="element-160" data-mp="3r7rirklevscd" />
          </p>
        </div>
      </div>
    </motion.div>;
}